import { DirectionFilter } from './types';

export function getSpecificDirection(direction?: DirectionFilter): DirectionFilter | undefined {
    const isSpecificDirection = direction && direction !== DirectionFilter.ALL;
    return isSpecificDirection ? direction : undefined;
}
